/**
 * @polymer
 * @mixinFunction
 **/
export const SyncActionBrowseBehavior = (superClass) => class extends superClass {
  static get properties() {
    return {
      _disabled: {type: Boolean, scopeVar: 'disabled'},
      disabled: {
        type: Boolean,
        computed: 'computeDisabled(dependsOnBrowse, browseSettled, _disabled)',
        observer: 'disabledChanged'
      },
      dependsOnBrowse: {type: String, reflectToAttribute: true, reflect: true},
      browseSettled: {type: Boolean}
    }
  }

  // Support LIT
  updated(changedProperties) {
    super.updated(changedProperties);

    if (changedProperties?.has('dependsOnBrowse') || changedProperties?.has('browseSettled') || changedProperties?.has('_disabled')) {
      this.disabled = this.computeDisabled(this.dependsOnBrowse, this.browseSettled, this._disabled);
    }
  }

  computeDisabled(dependsOnBrowse, browseSettled, _disabled) {
    if (dependsOnBrowse) {
      return !browseSettled || _disabled;
    }
    return !!_disabled;
  }
};